import I18n from "i18n-js";
import React from "react";
import { func, shape } from "prop-types";
import { connect } from "react-redux";
import { ROUTE_PRESSURE_GAUGES } from "../../../routes";
import { getLang } from "../../common/utils/langUtils";
import { getPressureGaugeInfos } from "../actions/pressureGaugesActions";
import FormPage from "../../common/components/layout/FormPage";
import ClientUtils from "../../company/utils/ClientUtils";

class PressureGauge extends FormPage {
  static propTypes = {
    clients: shape().isRequired,
    getPressureGaugeInfos: func.isRequired,
    pressureGauge: shape().isRequired,
    match: shape().isRequired,
  };

  /**
   * {@inheritdoc}
   */
  componentDidMount() {
    this.props.getPressureGaugeInfos(this.props.match.params.uuid);
  }

  /**
   * {@inheritdoc}
   */
  getTitle() {
    return I18n.t("pages.pressure_gauges.view.title");
  }

  /**
   * {@inheritdoc}
   */
  getBackRoute() {
    return ROUTE_PRESSURE_GAUGES;
  }

  /**
   * {@inheritdoc}
   */
  renderContent() {
    const { pressureGauge, clients } = this.props;
    const { infos } = pressureGauge;

    if (infos === undefined || clients.inProgress) {
      return <div className="loader" />;
    }

    if (infos === null) {
      return <p>{I18n.t("pages.pressure_gauges.view.unknown")}</p>;
    }

    const lastInspection = new Date(
      infos.lastInspectionDate,
    ).toLocaleDateString(getLang());
    const expirationDate = new Date(infos.expirationDate).toLocaleDateString(
      getLang(),
    );

    const currentDate = new Date();
    const expired = currentDate > new Date(infos.expirationDate);
    const expiration = (
      <div className={`text-${expired ? "danger" : "success"}`}>
        <i
          className={`fa-solid fa-${expired ? "times" : "check"}`}
          aria-hidden="true"
        />
      </div>
    );

    const owner =
      clients.list.find((client) => client.uuid === infos.clientUuid) || null;

    return (
      <div className="card card-block">
        <dl className="row">
          <dt className="col-sm-3">
            {I18n.t("pages.pressure_gauges.head.serial_number")}
          </dt>
          <dd className="col-sm-9">{pressureGauge.infos.serialNumber}</dd>

          <dt className="col-sm-3">
            {I18n.t("pages.pressure_gauges.head.last_inspection")}
          </dt>
          <dd className="col-sm-9">{lastInspection}</dd>

          <dt className="col-sm-3">
            {I18n.t("pages.pressure_gauges.head.validity")}
          </dt>
          <dd className="col-sm-9">{expiration}</dd>

          <dt className="col-sm-3">
            {I18n.t("pages.pressure_gauges.head.expiration_date")}
          </dt>
          <dd className="col-sm-9">{expirationDate}</dd>

          <dt className="col-sm-3">
            {I18n.t("pages.pressure_gauges.head.client")}
          </dt>
          <dd className="col-sm-9">
            {owner ? ClientUtils.renderLabel(owner) : I18n.t("common.unknown")}
          </dd>

          <dt className="col-sm-3">
            {I18n.t("pages.pressure_gauges.head.designation")}
          </dt>
          <dd className="col-sm-9">
            {pressureGauge.infos.designation || I18n.t("common.not_specified")}
          </dd>

          <dt className="col-sm-3">
            {I18n.t("pages.pressure_gauges.head.barcode")}
          </dt>
          <dd className="col-sm-9">
            {pressureGauge.infos.barcode || I18n.t("common.not_specified")}
          </dd>
        </dl>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  clients: state.clients,
  pressureGauge: state.pressureGauge,
});

const mapDispatchToProps = (dispatch) => ({
  getPressureGaugeInfos: (uuid) => dispatch(getPressureGaugeInfos(uuid)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PressureGauge);
